import React, { Component, useState } from 'react'
import DebtorsListRow from '../DebtorsListRow/DebtorsListRow'
import DebtorsForm from '../DebtorsForm/DebtorsForm'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { connect } from 'react-redux'
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
import moment from 'moment/moment'
import { Link } from 'react-router-dom'
import { AlertError, AlertSuccess } from '../../Alert/Alert'
import Loading from '../../Loading'
import {CarSellUtil, CarsUtil} from "../../../utils/carSellUtil";

pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew-Regular.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}


function DebtorBankEdit({ is_edit, bank_list, debtorEdit, onToggle, onSave }) {

  const [bank_id, setBankId] = useState(debtorEdit.bank_id);


  return (
    <Modal isOpen={is_edit} toggle={onToggle}
           className={'modal-warning '}>
      <ModalHeader toggle={onToggle}>แก้ไขข้อมูล: ช่องทางการรับชำระ</ModalHeader>
      <ModalBody>
        <div className="row">
          <div className="col-12">
            รายการ: {debtorEdit.debtors_name}
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-12 ">
            ช่องทางการรับชำระ(ธนาคาร): {debtorEdit.bank_name === null ? '-' : debtorEdit.bank_name}
            <select className="form-control"
                    id="bank_id"
                    name="bank_id"
                    defaultValue={bank_id}
                    onChange={(e) => {
                      let val = Number(e.target.value)
                      setBankId(val)
                    }}
            >
              <option value={0}>ไม่ระบุ</option>
              {
                bank_list.map((bank, index) => {

                  // if (bank.bank_id === bank_id) {
                  // return <option key={index} value={bank.bank_id} selected={true}>{bank.bank_name}</option>
                  // }
                  return <option key={index} value={bank.bank_id}>{bank.bank_name}</option>

                })
              }
            </select>
          </div>
        </div>

      </ModalBody>
      <ModalFooter>

        <Button color="danger" onClick={onToggle}>ยกเลิก</Button>
        {' '}
        <Button color="warning"
                onClick={() => {
                  if (debtorEdit.bank_id === bank_id ) {
                    AlertError('กรุณาเลือกธนาคาร')
                  } else {
                    let data = {
                      debtors_id: debtorEdit.debtors_id,
                      bank_id: bank_id
                    }
                    onSave(data)
                  }
                }}
        >แก้ไข</Button>

      </ModalFooter>
    </Modal>
  )
}


const port = Number(window.env.PORT);

class DebtorsList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: {},
      user_type: '',
      lists: [],
      load_data: true,
      danger: false,
      toggle_debtors_add: false,
      paymentdetail: false,
      selectCustomer: '',
      customer_id: 0,
      debtors_id: 0,
      action: 'บันทึก',
      customer: '',
      debtors: '',
      car_id: '',
      car: '',
      width: 0,
      height: 0,
      is_edit: false,
      debtor_edit: null,
      bank_list: [],
      isLoading: false,
      debtors_type_id: '',
      debtors_name: '',
      amount_of_debt: '',
      debtors_type : []
    }
    this.toggleDebtors = this.toggleDebtors.bind(this);
    this.togglePaymentDetail = this.togglePaymentDetail.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.loadBankData = this.loadBankData.bind(this);
    this.onDebtorEditToggle = this.onDebtorEditToggle.bind(this);
    this.onDebtorEditSave = this.onDebtorEditSave.bind(this);
    this.loadCarById = this.loadCarById.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.loadDebtorType = this.loadDebtorType.bind(this);
  }

  onDebtorEditToggle() {
    let is_edit = !this.state.is_edit

    if (is_edit === true) {
      this.setState({
        is_edit: is_edit,
      })
    } else {
      this.setState({
        is_edit: is_edit,
        debtor_edit: null
      })
    }
  }

  onDebtorEditSave(data) {
    this.setState({
      isLoading: true
    }, () => {
      let uri = APIURL+'/debtors/bank'
      axios.put(uri, data).then(res => {
        let resData = res.data

        if (resData === 'success') {
          AlertSuccess('แก้ไขข้อมูลเรียบร้อยแล้ว')
          this.loadDebtorsData();
          this.setState({
            isLoading: false,
            is_edit: false,
            debtor_edit: null
          })
        }
      }).catch(error => {
        console.log('error: ' + error)
      })
    })
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  componentWillMount () {
    //const queryString = require('query-string');
    var user = JSON.parse(this.props.user);
    this.setState({
      user: user ,
      user_type : user.type
    })
  }

  componentDidMount () {
    CarsUtil.removeCarSelect()
    CarSellUtil.removeCarSellSelect()

    this.mounted = true
    const queryString = require('query-string')
    let query = queryString.parse(this.props.location.search)

    if (Object.keys(query).length > 0) {
      // data from query parameter
      // {car_id: '188', customer_id: '77', debtors_type_id: '2'}
      this.setState({
        car_id: query.car_id,
        customer_id: query.customer_id,
        debtors_type_id: query.debtors_type_id,
        debtors_name: query.debtors_name,
        amount_of_debt: query.amount_of_debt,
      }, () => {
        this.loadCarById(true);
      })

    } else {
      this.loadDebtorsData()
      this.loadBankData()
    }

  }

  loadCarById(is_open_modal){
    //var that = this
    axios.get(APIURL + '/car/'+this.state.car_id)
      .then(res => {
        let car = res.data[0]
        this.setState({
          car: car,
        }, () => this.toggleDebtors())
      }).catch(error => {
      // alert("error"+error)
      this.setState({car: {}})
    })
  }

  loadBankData() {
    axios.get( APIURL + '/bank/').then(res => {
      this.setState({
        bank_list: res.data
      })
    }).catch(error => {
      console.log('error: ' + error)
    })
  }

  loadDebtorsData () {
    axios.get(APIURL + '/debtors_detail/sum/')
      .then(res => {
        if(res.status === 200) {
          let data = res.data.sort((a, b) => (a.debtors_id < b.debtors_id) ? 1 : -1)
          this.setState({lists: data})
        }
      }).catch(error => {
        this.setState({lists: []})
    })

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  toggleDebtors () {
    this.setState({
      toggle_debtors_add: !this.state.toggle_debtors_add
    })
    this.loadDebtorsData()
  }

  togglePaymentDetail () {
    this.setState({
      paymentdetail: !this.state.paymentdetail
    })
    this.loadDebtorsData()
  }

  addPaymentDetail (debtors) {
    this.setState({debtors_id: debtors.debtors_id})
    this.togglePaymentDetail()
  }

  loadDebtorType() {
    // debtors_type
    axios.get( APIURL + '/debtors_type/').then(res => {
      this.setState({
        debtors_type: res.data
      })
    }).catch(error => {

    })
  }

  onSearch(){
    let search_text = this.refs.input_search.value

    if(search_text==='')
      return;

    axios.get(APIURL + '/debtors_detail/search/'+search_text)
      .then(res => {
        if(res.status === 200) {
          let data = res.data.sort((a, b) => (a.debtors_id < b.debtors_id) ? 1 : -1)
          this.setState({lists: data})
        }
      }).catch(error => {
      console.log('error: ' + error)
        this.setState({lists: []})
    })
  }

  deleteDebtors(debtor_del) {

    if(window.confirm('ท่านต้องการลบ '+debtor_del.debtors_name +'\nยอดหนี้ '+debtor_del.amount_of_debt.toLocaleString()+' ใช่หรือไม่? (ลบแล้วไม่สามารถกู้คืนได้)')) {
      let debtorList = this.state.lists.filter(debtors => debtors.debtors_id !== debtor_del.debtors_id)

      axios.delete(APIURL + '/debtors/'+debtor_del.debtors_id)
        .then(res => {

          if(res.status === 200) {
            this.setState({lists: debtorList})
          }
        }).catch(error => {
        this.setState({lists: []})
        console.log('error: ' + error)
      })

    }
  }

 bankEdit(debtor) {
    // open modal for edit
   this.setState({
     debtor_edit: debtor,
     is_edit: true
   })
 }

  printDebtors(debtor) {
    let debtors_id = debtor.debtors_id
    let car_sell_id = debtor.car_sell_id

    axios.get(APIURL + '/debtors_detail/debtors_id/' + debtors_id)
      .then(res => {
        if(res.status === 200) {
          let debtorsDetail = res.data
          axios.get(APIURL + '/car_sell/' + car_sell_id)
            .then(res2 => {
              var car_sell = res2.data
              this.printDebtorsPdf(debtor, debtorsDetail, car_sell)
            })
        }
      }).catch(error => {
        console.log('error: ' + error)
    })

  }

  printDebtorsPdf(debtor, debtorsDetail, car_sell){

    let debtors_name = debtor.debtors_name
    let date_pay_start = "จ่ายทุกวันที่ " + moment( debtor.date_pay_start).format('DD')
    let customer_mobile = debtor.customer_mobile
    let customer_name = debtor.customer_name+' '+debtor.customer_lastname
    // var debtors_other = debtor.debtors_other

    var car_sell_user = car_sell.length > 0 ? car_sell[0].car_sell_user : '-'
    var promotion_name = car_sell.length > 0 ? car_sell[0].promotion_name : '-'

    // return;

    var row1 = {
      columns: [
        { width: '10%',
          text: 'รายการ', style: 'textBoldLeft'
        },
        { width: '90%', style: 'textNormal',
          text: debtors_name,
        },
      ],
      columnGap: 20,
      lineHeight:1
    }

    var row2 = {
      columns: [
        { width: '10%',
          text: 'ชื่อผู้ซื้อ', style: 'textBoldLeft'
        },
        { width: '40%', style: 'textNormal',
          text: customer_name + ' ' + customer_mobile,
        },
        { width: '20%',
          text: 'โปรโมชั่น', style: 'textBoldLeft'
        },
        { width: '30%', style: 'textNormal',
          text: promotion_name,
        },
      ],
      columnGap: 20,
      lineHeight:1
    }
    var row3 = {
      columns: [
        { width: '10%',
          text: 'เซลล์', style: 'textBoldLeft'
        },
        {
          width: '40%', style: 'textNormal',
          text: car_sell_user,
        },
        { width: '20%',
          text: 'วันที่จ่ายค่างวด', style: 'textBoldLeft'
        },
        {
          width: '30%', style: 'textNormal',
          text: date_pay_start,
        }
      ],
      columnGap: 20,
      lineHeight:1.5
    }


    var  deptAllRows = []
    var tableHeader = [
      { style: 'textBold', text: 'งวดที่',},
      { style: 'textBold', text: 'กำหนดชำระ',},
      { style: 'textBold', text: 'จำนวนเงิน',},
      { style: 'textBold', text: 'วันที่ชำระ',},
      { style: 'textBold', text: 'ผู้รับเงิน',},
    ];
    deptAllRows.push(tableHeader);

    debtorsDetail.forEach((debtor, index) => {
      var order = debtor.debtors_detail_order
      var date_dept = moment(debtor.date_dept).format('DD-MM-YYYY')
      var amount_dept = debtor.amount_dept.toLocaleString()
      var amount_pay = debtor.amount_pay === 0 ? ' ' : debtor.amount_pay.toLocaleString()
      var date_pay =  debtor.date_pay === '0000-00-00' ? ' ' : moment(debtor.date_pay).format('DD-MM-YYYY')

      var row = []

      var itemOrder = {
        text: order,
        style: 'textCenter'
      };
      var itemDateDept = {
        text: date_dept,
        style: 'textCenter'
      };
      var itemAmountDept = {
        text: amount_dept,
        style: 'textCenter'
      };

      var itemAmountPay = {
        text: amount_pay,
        style: 'textCenter'
      };
      var itemDatePay = {
        text: date_pay,
        style: 'textCenter'
      };


      row.push(itemOrder)
      row.push(itemDateDept)
      row.push(itemAmountDept)
      row.push(itemAmountPay)
      row.push(itemDatePay)

      deptAllRows.push(row);
    })

    var docDefinition = {
      pageOrientation: 'portrait',
      pageSize: 'A4',
      pageMargins: [40, 30, 40, 0],
      // background: {image: 'book', width: 600},
      content: [
        {text: 'ใบผ่อนชำระ', style: 'bodyhead', lineHeight: 1.3},
        row1,
        row2,
        row3,
        {
          columns: [
            { width: '15%',
              text: port === 9016 ? ' การชำระเงิน ' : '', style: 'textBoldLeft'
            },
            {
              width: '85%', style: 'textNormal',
              text: port === 9016  ? ' โอนเข้าบัญชีธนาคารไทยพาณิชย์ เลขที่บัญชี 698-2-15783-0 ชื่อบัญชีนายปฐมพงศ์ ประเทืองไพศรี ' : ''
            },
          ],
          columnGap: 20,
          lineHeight:1
        },
        {text: ' ', style: 'bodyhead', lineHeight: 0.5},
        {
          table: {
            headerRows: 1,
            widths: ['10%','20%', '20%', '*', '*'],
            body: deptAllRows
          }
        },
      ],
      styles: {
        bodyhead: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        textNormal: {
          fontSize: 16,
        },
        textBold: {
          fontSize: 16,
          bold: true,
          alignment: 'center'
        },
        textBoldRight: {
          fontSize: 16,
          bold: true,
          alignment: 'right'
        },
        textBoldLeft: {
          fontSize: 16,
          bold: true,
          alignment: 'left'
        },
        textCenter: {
          fontSize: 16,
          alignment: 'center'
        }
      },
      defaultStyle: {
        font: 'THSarabunNew'
      }
    }
    pdfMake.createPdf(docDefinition).open();
  }

  onRefresh(){
    this.refs.input_search.value = ''
    this.loadDebtorsData()
  }

  render () {

    let width = this.state.width
    let width_box = 180
    if (width <= 980){
      width_box = 112
    }

    return (
      <div className="card">
        <div className="card-block">
          <div className="">
            <Loading isLoading={this.state.isLoading} />

            {
              this.state.debtor_edit !== null ? (
                <DebtorBankEdit
                  is_edit={this.state.is_edit}
                  debtorEdit={this.state.debtor_edit}
                  bank_list={this.state.bank_list}

                  onToggle={() => this.onDebtorEditToggle()}

                  onSave = {(data) => this.onDebtorEditSave(data)}

                />
              ) : null
            }

            <div className="card card-accent-info">
                <div className="card-header card-customer">
                  <div className="row">
                    <div className="form-group form-inline col-12">
                      <div className="row">
                        <strong className="text-title ml-1 mt-2"> ข้อมูลบัญชีลูกหนี้ </strong>
                          <input
                            ref="input_search"
                            style={styles.inputSearch}
                            className="form-control mr-2"
                            placeholder="ค้นหาตามชื่อ เบอร์โทร หรือทะเบียนรถใหม่"
                            type="text"
                          />

                          {/*<select className="form-control mr-1"
                                  style={{...styles.selectFilter, width: width_box}}
                                  name="debtors_type_id"
                                  value={this.state.debtors_type_id}
                                  onChange={(e) => {
                                    this.setState({debtors_type_id: e.target.value}, () => this.onSearch())
                                  }}
                          >
                            <option value="">ประเภทลูกหนี้</option>
                            {debtors_type_list}
                          </select>*/}

                          &nbsp;
                          <button
                            className="btn btn-sm btn-head-bar mr-1"
                            //onClick={this.onSearch.bind(this)}
                            onClick={() => this.onSearch()}
                            style={styles.buttonHeight}
                          >
                            <i className="icon-search"/>ค้นหา
                          </button>

                          <button className="btn btn-head-bar"
                                  style={styles.buttonHeight}
                                  onClick={this.onRefresh.bind(this)}

                          >
                            <i className="icon-refresh"/>
                          </button>

                          {
                            this.state.user.type === 'admin' || this.state.user.type === 'manager' || this.state.user.type === 'account' ? (
                              <Link to="/report/debtors">
                                <button className="btn btn-head-bar float-right mt-1 ml-2 mr-2" style={{backgroundColor: '#4dbd74'}}>
                                  <i className="icon-doc"/>&nbsp; รายงานลูกหนี้
                                </button>
                              </Link>
                            ) : null
                          }

                          <button type="button"
                                  onClick={this.toggleDebtors}
                                  className="btn btn-head-bar float-right mt-1 ">
                            <i className="icon-plus"/>&nbsp; เพิ่มข้อมูลลูกหนี้
                          </button>


                          {
                            this.state.toggle_debtors_add === true ? (
                              <Modal isOpen={this.state.toggle_debtors_add} toggle={this.toggleDebtors}
                                     className={'modal-lg'}
                                     style={width<=980 ?{maxWidth:800}:{maxWidth:1200}}
                              >
                                <ModalBody>
                                  <DebtorsForm
                                    // onLoadDebtors ={this.loadCarData}
                                    car_id={this.state.car_id}
                                    customer_id={this.state.customer_id}
                                    debtors_type_id={this.state.debtors_type_id}
                                    debtors_name={this.state.debtors_name}
                                    amount_of_debt={this.state.amount_of_debt}
                                    car={this.state.car}
                                    onToggle={this.toggleDebtors}

                                  />
                                </ModalBody>
                              </Modal>
                            ) : null
                          }
                        </div>
                    </div>
                  </div>
                </div>

                <DebtorsListRow
                  debtors_list={this.state.lists}
                  debtorsCallbacks={
                    {
                      add: this.addPaymentDetail.bind(this),
                      del: this.deleteDebtors.bind(this),
                      print: this.printDebtors.bind(this),
                      bankEdit: this.bankEdit.bind(this),
                    }
                  }
                  user_type={this.state.user_type}
                />

              </div>
          </div>
        </div>
      </div>
    )
  }

}

const styles = {
  bottomLine: {
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid',
    borderWidth: 0.5,
  },
  inputSearch: {
    marginLeft: 20,
    width: 300,
    display: 'inline'
  },

  buttonHeight: {
    height: 36,
    paddingTop: 0,
    paddingBottom:0,
    borderRadius:5,
    display: 'inline',
    marginTop: 5,
    marginBottom: -8,
  },

  selectFilter: {
    marginTop: 5,
    marginBottom: -8,
    borderRadius:5,
    display: 'inline'
  },

  overflowY: {
    overflow: 'scroll',
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(DebtorsList)
